<template>
  <v-list-item @dblclick="editing = true" @blur="editing = false">
    <v-list-item-icon class="mr-2">
      <v-icon :color="noteStatuses[card.state || 0].color">
        {{ noteStatuses[card.state || 0].icon }}
      </v-icon>
    </v-list-item-icon>
    <v-list-item-title>
      <content-editor
        :value="{ html: card.title }"
        @input="
          updateCardTitle({
            pageId: page.id,
            cardId: card.id,
            title: $event
          })
        "
        @mousedown.stop
        style="cursor: text; width: 100%;"
        :ref="card.id"
        :class="{ ellipsis: true, editing: editing }"
        placeholder="Untitled Page"
        allowTraversal
        :emitText="true"
        :preventTab="true"
        @keyDownLastLine="$emit('traverseNoteCards', { direction: 'down', event: $event, index })"
        @keyUpFirstLine="$emit('traverseNoteCards', { direction: 'up', event: $event, index })"
        @keyEnter="editing = false"
        @keyShiftTab=""
        :disabled="!editing"
      ></content-editor>
    </v-list-item-title>
    <v-list-item-icon
      v-for="(item, index) in users[card.id]"
      :key="item.id"
      :class="{ 'mx-0': true, 'pl-1': !index }"
    >
      <user-avatar size="20px" :avatarUrl="item.avatar"></user-avatar>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
import noteStatusesMixin from '../mixins/noteStatusesMixin';
import UserAvatar from '@/components/UserAvatar';
import ContentEditor from '@/components/ContentEditor';

import { mapActions } from 'vuex';

export default {
  mixins: [noteStatusesMixin],
  components: { UserAvatar, ContentEditor },
  props: ['page', 'card', 'users'],
  data() {
    return {
      editing: false
    };
  },
  methods: {
    ...mapActions('pages', ['updateCardTitle', 'addCard'])
  }
};
</script>

<style>
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
